import {type} from '../utilities/type';
import {Action} from '@ngrx/store';
import {ServerForm} from '../models/servers';

export const serverActionTypes = {
  LOAD: type('[Server] Load'),
  LOAD_BY_TYPE: type('[Server] Load By Type'),
  LOAD_SUCCESS: type('[Server] Load Success'),
  LOAD_FAIL: type('[Server] Load Server Error'),
  CLEAR: type('[Server] Clear Server '),
};

export class LoadServerAction implements Action {
  readonly type = serverActionTypes.LOAD;
  constructor() {}
}
export class LoadServerByTypeAction implements Action {
  readonly type = serverActionTypes.LOAD_BY_TYPE;
  constructor(public payload?: string) {}
}


export class LoadServerSuccessAction implements Action {
  readonly type = serverActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ServerForm[]) {}
}

export class LoadServerFailAction implements Action {
  readonly type = serverActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class ClearServerAction implements Action {
  readonly type = serverActionTypes.CLEAR;
  constructor() {
  }
}
